import React from "react";
import { Link } from "react-router-dom";
import { Button, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { LeftChevron } from "../../../common/js/icons";

const PageToolbar = styled("div")({
    margin: "20px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
});

const PageToolbarBackNavigation = styled("div")({
    display: "flex",
    paddingBottom: "2px",
    paddingRight: "0px",
    flexDirection: "row",
    alignItems: "end",
});

const LeftIcon = styled("div")({
    marginLeft: "25px",
});

const ProgressDiv = styled("div")({
    textAlign: "center",
    width: "5em",
    display: "inline-block",
});

const AddContactToolbar = (props) => {
    const { createContact, elementsSaving, history, newContact, updateContact } = props;

    const handleSaveContact = async () => {
        const result = newContact ? await createContact() : await updateContact();
        if (result.success) {
            history.push("/contacts");
        }
    };

    const handleCancelChanges = () => {
        history.push("/contacts");
    };

    return (
        <PageToolbar>
            <PageToolbarBackNavigation>
                <Link to="/contacts">
                    <LeftChevron />
                </Link>
                <h2 className="page-title">{newContact ? "Add New Contact" : "Edit Contact"}</h2>
            </PageToolbarBackNavigation>

            <LeftIcon>
                <Button variant="outlined" color="primary" onClick={handleCancelChanges}>
                    Cancel
                </Button>
                {elementsSaving.submit ? (
                    <ProgressDiv>
                        <CircularProgress size={20} color="primary" />
                    </ProgressDiv>
                ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        // onClick={newContact ? handleSaveContactcreateContact : updateContact}
                        onClick={handleSaveContact}
                    >
                        Save
                    </Button>
                )}
            </LeftIcon>
        </PageToolbar>
    );
};

export default AddContactToolbar;
